import http from 'plugins/axios';

export default {
  getWithdrawList(data) {
    return http.get({
      url: '/ta/admin/tenant/withdraw/limit/switch',
      data
    });
  },
  deleteWithdrawLimit({ userId }) {
    return http.post({
      url: `/ta/admin/tenant/delete/withdraw/limit?userId=${userId}`
    });
  }
};
